import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
@Injectable({
  providedIn: 'root',
})
export class SiaTokenStoreService {
  tokenKey: string = 'token';
  /**
   *
   */
  constructor() {}
  setToken(token: any) {
    this.clearStore();
    if (token) {
      window.sessionStorage.setItem(this.tokenKey, JSON.stringify(token));
      window.localStorage.setItem('refresh-token', token['refresh_token']);
    }
  }

  getToken() {
    let tokenJson = window.sessionStorage.getItem(this.tokenKey);
    if (tokenJson) {
      let r = JSON.parse(tokenJson);
      return r;
    }
  }
  getRefreshToken(): string | null {
    return window.localStorage.getItem('refresh-token');
  }
  clearStore() {
    window.sessionStorage.removeItem(this.tokenKey);
    window.localStorage.removeItem('refresh-token');
  }
  clearToken() {
    window.sessionStorage.removeItem(this.tokenKey);
  }

  getAccessToken(): string | null {
    let t = this.getToken();
    if (!t) {
      return null;
    }
    return t.access_token;
  }

  isCurrentTokenExpiring() {
    let token = this.getAccessToken();
    if (!token) {
      return true;
    }
    return this.#isExpiring(token);
  }

  isCurrentTokenExpired() {
    let token = this.getAccessToken();
    if (!token) {
      return true;
    }
    return this.#isExpired(token);
  }

  #isExpiring(token: string): boolean {
    const helper = new JwtHelperService();
    const expirationDate: Date | null = helper.getTokenExpirationDate(token);
    const isExpired = helper.isTokenExpired(token);
    if (isExpired) {
      return true;
    }
    if (!expirationDate) return true;
    let d2 = new Date(expirationDate);
    d2.setMinutes(d2.getMinutes() - 10);
    return d2 < new Date();
  }

  async #isExpired(token: string): Promise<boolean> {
    const helper = new JwtHelperService();
    const expirationDate: Date | null = helper.getTokenExpirationDate(token);
    const isExpired = await helper.isTokenExpired(token);
    return isExpired;
  }
}
